export const messages = {
    en: {
        addToFavorites: "Successfully added to your favorites",
        removeFromFavorites: "Successfully removed from your favorites",
        nameEmpty: "Name cannot be empty",
        emailEmpty: "Email Address cannot be empty",
        emailNotValid: "Email Address is not valid",
        locationEmpty: "Location cannot be empty",
        interests: "Select 3 area of interest.",
        profileSaved: "Profile detail saved",
        profilePic: "Profile Picture Saved",
    },
    ee: {
        addToFavorites: "Sinu lemmikutesse lisamine õnnestus",
        removeFromFavorites: "Sinu lemmikutest eemaldamine õnnestus",
        nameEmpty: "Nimi ei saa olla tühi",
        emailEmpty: "E-posti aadress ei saa olla tühi",
        emailNotValid: "E-posti aadress ei kehti",
        locationEmpty: "Asukoht ei saa olla tühi",
        interests: "Vali 3 huviala",
        profileSaved: "Profiili üksikasjad on salvestatud",
        profilePic: "Profiilipilt salvestatud",
    },
    fr: {
        addToFavorites: "Ajouté à vos favoris",
        removeFromFavorites: "Supprimé de vos favoris",
        nameEmpty: "Le nom ne peut pas être vide",
        emailEmpty: "L'adresse e-mail ne peut pas être vide",
        emailNotValid: "L'adresse email n'est pas valide",
        locationEmpty: "L'emplacement ne peut pas être vide",
        interests: "Sélectionnez 3 zones d'intérêt.",
        profileSaved: "Détails du profil sauvegardés",
        profilePic: "Image de profil enregistrée",
    },
    es: {
        addToFavorites: "Añadido correctamente a tu lista de ver más tarde",
        removeFromFavorites:
            "Eliminado correctamente de tu lista de ver más tarde",
        nameEmpty: "El nombre no puede estar vacío",
        emailEmpty: "La dirección de correo electrónico no puede estar vacía",
        emailNotValid:
            "La dirección de correo electrónico no es válida, ingrese una dirección de correo electrónico adecuada",
        locationEmpty: "La ubicación no puede estar vacía",
        interests: "Selecciona 3 áreas de interés.",
        profileSaved: "Datos de perfil guardados",
        profilePic: "Imagen de perfil guardada",
    },
    be: {
        addToFavorites: "Succesvol toegevoegd aan uw favoriet",
        removeFromFavorites: " Succesvol verwijderd van de favoriet",
        nameEmpty: "Naam mag niet leeg zijn",
        emailEmpty: "E-mailadres mag niet leeg zijn",
        emailNotValid: "E-mailadres is niet geldig",
        locationEmpty: "Locatie mag niet leeg zijn",
        interests: "Selecteer 3 interessegebieden.",
        profileSaved: "Profiel detail opgeslagen",
        profilePic: "Profielfoto opgeslagen",
    },
    it: {
        addToFavorites: "Aggiunto ai tuoi preferiti",
        removeFromFavorites: "Rimosso dai preferiti",
        nameEmpty: "Il nome non può essere vuoto.",
        emailEmpty: "L'indirizzo e-mail non può essere vuoto.",
        emailNotValid:
            "L'indirizzo e-mail non è valido, inserisci un indirizzo e-mail corretto.",
        locationEmpty: "Location cannot be empty",
        interests: "Select 3 area of interest.",
        profileSaved: "Dato del profilo salvato",
        profilePic: "Foto del profilo salvata.",
    },
    id: {
        addToFavorites: "Berhasil ditambahkan ke favorit",
        removeFromFavorites: "Berhasil dihapus dari favorit",
        nameEmpty: "Nama tidak boleh kosong",
        emailEmpty: "Alamat Email tidak boleh kosong",
        emailNotValid: "Alamat email tidak valid",
        locationEmpty: "Lokasi tidak boleh kosong",
        interests: "Pilih 3 bidang yang diminati",
        profileSaved: "Detail profil disimpan",
        profilePic: "Gambar Profil Disimpan",
    },
    se: {
        addToFavorites: "Framgångsrikt tillagt till din favorit",
        removeFromFavorites: "framgångsrikt borttaget från favorit",
        nameEmpty: "Namnet kan inte vara tomt",
        emailEmpty: "E-postadressen kan inte vara tom",
        emailNotValid: "E-postadressen är inte giltig",
        locationEmpty: "Platsen kan inte vara tom",
        interests: "Välj 3 intressanta områden.",
        profileSaved: "Profiluppgifter sparade.",
        profilePic: "Profile Picture Saved",
    },
    ar: {
        addToFavorites: "تمت إضافته بنجاح إلى المفضلة لديك",
        removeFromFavorites: "تمت إزالته بنجاح من المفضلة",
        nameEmpty: "لا يمكن أن يكون الاسم فارغًا",
        emailEmpty: "لا يمكن أن يكون عنوان البريد الإلكتروني فارغًا",
        emailNotValid: "عنوان البريد الإلكتروني غير صالح",
        locationEmpty: "لا يمكن أن يكون الموقع فارغًا",
        interests: "حدد 3 مجالات اهتمام",
        profileSaved: "تم حفظ تفاصيل الملف الشخصي",
        profilePic: "تم حفظ صورة الملف الشخصي",
    },
    no: {
        addToFavorites: "Lagt til favoritten din",
        removeFromFavorites: "Fjernet fra favoritten",
        nameEmpty: "Navnet kan ikke være tomt",
        emailEmpty: "E-postadressen kan ikke være tom",
        emailNotValid: "E-postadressen er ikke gyldig",
        locationEmpty: "Plasseringen kan ikke være tom",
        interests: "Velg 3 interesseområder",
        profileSaved: "Profilopplysning lagret",
        profilePic: "Profilbilde lagret",
    },
    lv: {
        addToFavorites: "Veiksmīgi pievienots jūsu izlasei",
        removeFromFavorites: "Veiksmīgi noņemts no izlases",
        nameEmpty: "Vārds, uzvārds nevar būt tukšs",
        emailEmpty: "E-pasta adrese nevar būt tukša",
        emailNotValid: "E-pasta adrese nav derīga",
        locationEmpty: "Atrašanās vieta nevar būt tukša",
        interests: "Izvēlieties 3 interesējošos žanrus",
        profileSaved: "Profila informācija saglabāta",
        profilePic: "Profila attēls saglabāts",
    },
    lt: {
        addToFavorites: "Sėkmingai pridėta prie jūsų mėgstamiausiųjų",
        removeFromFavorites: "Sėkmingai pašalinta iš mėgstamiausiųjų",
        nameEmpty: "Vardo laukelis privalo būti užpildytas",
        emailEmpty: "El. pašto laukelis privalo būti užpildytas",
        emailNotValid: "Neteisingas el. pašto adresas",
        locationEmpty: "Vietovės laukelis privalo būti užpildytas",
        interests: "Pasirinkite 3 dominančias sritis",
        profileSaved: "Profilio duomenys išsaugoti",
        profilePic: "Profilio nuotrauka išsaugota",
    },
    sr: {
        addToFavorites: "Успешно сте додали у омиљене",
        removeFromFavorites: "Успешно сте избацили из омиљених",
        nameEmpty: "Поље за име не може бити празно.",
        emailEmpty: "Поље за имејл адресу не може бити празно.",
        emailNotValid: "Имејл адреса није валидна",
        locationEmpty: "Поље за локацију не може бити празно.",
        interests: "Изаберите 3 подручја интересовања",
        profileSaved: "Профилни подаци снимљени.",
        profilePic: "Профилна слика снимљена.",
    },
    th: {
        addToFavorites: "เพิ่มไปยังรายการโปรดของคุณสำเร็จ",
        removeFromFavorites: "ลบออกจากรายการโปรดของคุณสำเร็จ",
        nameEmpty: "เว้นว่างชื่อไม่ได้",
        emailEmpty: "ที่อยู่อีเมลไม่สามารถเว้นว่าง",
        emailNotValid: "ที่อยู่อีเมลไม่ถูกต้อง",
        locationEmpty: "ตำแหน่งไม่สามารถเว้นว่าง",
        interests: "เลือกความสนใจ 3 รายการ",
        profileSaved: "รายละเอียดโปรไฟล์ถูกบันทึก",
        profilePic: "รูปภาพโปรไฟล์ถูกบันทึก",
    },
    el: {
        addToFavorites: "Προστέθηκε επιτυχώς στα αγαπημένα σας",
        removeFromFavorites: "Καταργήθηκε με επιτυχία από το αγαπημένα σας",
        nameEmpty: "Το όνομα δεν μπορεί να είναι κενό",
        emailEmpty:
            "Η διεύθυνση ηλεκτρονικού ταχυδρομείου δεν μπορεί να είναι κενή",
        emailNotValid: "Η διεύθυνση ηλεκτρονικού ταχυδρομείου δεν είναι έγκυρη",
        locationEmpty: "Η τοποθεσία δεν μπορεί να είναι κενή",
        interests: "Επιλέξτε 3 περιοχές ενδιαφέροντος",
        profileSaved: "Οι λεπτομέρειες προφίλ αποθηκεύτηκαν",
        profilePic: "Η εικόνα προφίλ αποθηκεύτηκε",
    },
    de: {
        addToFavorites: "Erfolgreich zu Ihren Favoriten hinzugefügt",
        removeFromFavorites: "Erfolgreich aus den Favoriten entfernt",
        nameEmpty: "Name darf nicht leer sein",
        emailEmpty: "E-Mail Adresse darf nicht leer sein",
        emailNotValid: "E-Mail-Adresse ist nicht gültig",
        locationEmpty: "Standort kann nicht leer sein",
        interests: "Wählen Sie 3 Interessebereiche.",
        profileSaved: "Profildetails gespeichert",
        profilePic: "Profilbild gespeichert",
    },
    cs: {
        addToFavorites: "Úspěšně přidáno do oblíbených",
        removeFromFavorites: "Úspěšně odebráno z oblíbených",
        nameEmpty: "Název nemůže být prázdný",
        emailEmpty: "E-mailová adresa nemůže být prázdná",
        emailNotValid: "E-mailová adresa není platná",
        locationEmpty: "Místo nemůže být prázdné",
        interests: "Vyberte 3 oblasti zájmu",
        profileSaved: "Podrobnosti profilu uloženy",
        profilePic: "Profilový obrázek byl uložen",
    },
    es: {
        profileSaved: "Detalle del perfil guardado",
        profilePic: "Imagen de perfil guardada",
        nameEmpty: "El nombre no puede estar vacío",
        emailEmpty: "La dirección de correo electrónico no puede estar vacía",
        emailNotValid: "La dirección de correo electrónico no es válida",
        locationEmpty: "La ubicación no puede estar vacía",
        addToFavorites: "Añadido con éxito a tus favoritos",
        removeFromFavorites: "Eliminado con éxito de los favoritos",
    },
    pt: {
        profileSaved: "Detalhe do perfil salvo",
        profilePic: "Foto de Perfil Salvo",
        nameEmpty: "O nome não pode estar vazio",
        emailEmpty: "O endereço de e-mail não pode estar vazio",
        emailNotValid: "O endereço de e-mail não é válido",
        locationEmpty: "O local não pode estar vazio",
        interests: "Selecione 3 áreas de interesse",
        addToFavorites: "Adicionado com sucesso aos seus favoritos",
        removeFromFavorites: "Removido com sucesso dos favoritos",
    },
};



// WEBPACK FOOTER //
// ./src/constants/messages.js